import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { ElkoninBox } from 'amira-intervention-library';
import useBlendingActivityWordMetadata from "../sharedHooks/useBlendingActivityWordMetadata";
import { withCurrentStoryWordMetadata } from '../../../../../context/CurrentStoryMetadataContext';

export default function ElkoninTutor({
  speech,
  phrase,
  isFTUE,
  currentWordIndex,
  setDisableInterventionsForPhrase,
  exampleWord,
  advanceOneWord,
  startPhrase,
  paused,
  resumePhrase,
  setWillHandlePause,
  currentPhraseWordMetadata,
}) {
  const { wordMetadata, error, loading, word, exampleWordMetadata } = useBlendingActivityWordMetadata({
    phrase,
    phraseMetadata: currentPhraseWordMetadata,
    exampleWord,
  });

  useEffect(() => {
    setDisableInterventionsForPhrase(true);
  }, []);

  if (loading) {
    return null; // fetching word metadata
  }

  const onEnd = () => {
    return;
  }

  return (
    <ElkoninBox
      version={99} //TODO: figure out if this is the one we want to start with
      speech={speech}
      word={word}
      wordMetadata={wordMetadata}
      endOfPhrase={false} //TODO: figure out implications
      handleMessage={onEnd}
      tutorMode={true}
      ftue={isFTUE}
      phrase={phrase}
      currentWordIndex={currentWordIndex}
      exampleWord={exampleWord}
      advanceOneWord={advanceOneWord}
      exampleWordMetadata={exampleWordMetadata}
      startPhrase={startPhrase}
      paused={paused}
      resumePhrase={resumePhrase}
      setWillHandlePause={setWillHandlePause}
    />
  );
}

ElkoninTutor.propTypes = {
  speech: PropTypes.object.isRequired,
  phrase: PropTypes.string.isRequired,
  isFTUE: PropTypes.bool.isRequired,
  setDisableInterventionsForPhrase: PropTypes.func.isRequired,
  startPhrase: PropTypes.func.isRequired,
  paused: PropTypes.bool.isRequired,
  resumePhrase: PropTypes.func.isRequired,
  setWillHandlePause: PropTypes.func.isRequired,
}